<template>
  <div class="row m-0" v-if="validUrl == false">

    <div class="col-12">
      <div class="alert alert-danger" role="alert">
        Url inválida!
      </div>
    </div>

  </div>
</template>

<script>
import makeToast from '../../mixins/makeToast';
import login from '../../mixins/login';
export default {
  name: 'CartaoCreditoAppAss',
  data() {
    return {
      loading: false,
      validUrl: false,
      Fields: {
        email: '',
        password: ''
      },
    };
  },
  mixins: [makeToast, login],
  created() {
    if(this.$route.params.type) {
      this.validUrl = true;
      var data = atob(this.$route.params.type);
      var array = data.split('#*#');
      
      this.Fields.email = array[0];
      this.Fields.password = array[1];

      this.realizarLogin();
    }
  },
  methods: {
    realizarLogin() {
      if(this.Fields.email == '' || this.Fields.password == '') {
        this.validUrl = false;
        return;
      }
      
      this.login(this.Fields.email, this.Fields.password, true);
    }
  },
};
</script>
